import { CAMPAIGN as BASE } from "../route";
export const APIACCOUNTS = BASE.sub("/apiaccounts");
export const APIACCOUNT = BASE.sub("/apiaccounts/:apiAccountId");
